import { useState } from 'react';
import { Button, Card } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { BulletStatus } from 'components/bullet-status/bullet-status';
import PageWithTitleLayout from 'components/layouts/page-with-title/page-with-title-layout';
import MuiDataTable from 'components/mui-data-table/mui-data-table';
import { useNewsListQuery, useNewsSeenMutation } from 'app/store';
import { noRowsTitle, timeConverter } from 'utils/utils';
import { NewsItemType } from 'features/news/news.types';
import ShowNewsDialog from './show-news';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';

const NewsListDataTable = (): JSX.Element => {
    const [page, setPage] = useState<number>(1);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedNews, setSelectedNews] = useState<NewsItemType | null>(null);

    const [newsSeen] = useNewsSeenMutation();
    const {
        data,
        isFetching: isLoadingData,
        isSuccess,
        refetch,
    } = useNewsListQuery({
        page: page,
        perPage: 15,
    });

    const rowsData: NewsItemType[] = data?.items ?? [];

    const handleShowNews = (news: NewsItemType) => {
        setSelectedNews(news);
        setIsDialogOpen(true);
        if (!news.read_news) newsSeen(news.id);
    };

    const handleCloseNews = () => {
        setIsDialogOpen(false);
    };

    const columns: GridColDef[] = [
        {
            field: 'id',
            width: 80,
            headerName: '#',
        },
        {
            field: 'title',
            headerName: 'عنوان اطلاعیه',
            minWidth: 130,
        },
        {
            field: 'text',
            headerName: 'متن اطلاعیه',
            minWidth: 140,
        },
        {
            field: 'read_news',
            headerName: 'وضعیت مشاهده',
            minWidth: 130,
            renderCell: ({ row }) => (
                <BulletStatus
                    type={!!row?.read_news ? 'success' : 'error'}
                    label={!!row?.read_news ? 'مشاهده شده' : 'مشاهده نشده'}
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'زمان اطلاعیه',
            minWidth: 140,
            renderCell: ({ row }) => timeConverter(row.created_at),
        },
        {
            field: 'buttons',
            headerName: '',
            width: 150,
            renderCell: ({ row }) => (
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleShowNews(row)}
                >
                    مشاهده اطلاعیه
                </Button>
            ),
        },
    ];

    return (
        <>
            <HelmetTabComponent title="اطلاعیه ها" />

            <PageWithTitleLayout title="لیست اطلاعیه ها">
                <Card variant="outlined">
                    <MuiDataTable
                        rows={rowsData}
                        columns={columns}
                        isLoading={isLoadingData}
                        isSuccess={isSuccess}
                        onRefetch={refetch}
                        paginateInfo={data?.pagination}
                        setPage={setPage}
                        noRowsMessage={noRowsTitle('اطلاعیه ای')}
                    />
                </Card>
            </PageWithTitleLayout>

            <ShowNewsDialog
                news={selectedNews}
                isOpen={isDialogOpen}
                onClose={handleCloseNews}
            />
        </>
    );
};

export default NewsListDataTable;
